import { render, staticRenderFns } from "./OverviewDashboard.vue?vue&type=template&id=3cc24f9e&"
import script from "./OverviewDashboard.vue?vue&type=script&lang=js&"
export * from "./OverviewDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports